var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookMobileReelChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 9,
  height: 6,
  fill: "none",
  viewBox: "0 0 9 6",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M1.483.246A.875.875 0 0 0 .246 1.483l3.5 3.5a.875.875 0 0 0 1.237 0l3.5-3.5A.875.875 0 0 0 7.246.246L4.364 3.127z"
})));
export default SvgFacebookMobileReelChevronDown;